import { useEffect } from "react";
import socket from "../../socket";

export const useAlertSocket = (studentId, handlers) => {
  useEffect(() => {
    // Store handlers in refs to avoid unnecessary reconnections
    const onNew = handlers.onNew || (() => {});
    const onUpdate = handlers.onUpdate || (() => {});
    const onDelete = handlers.onDelete || (() => {});
    
    socket.on("alert:new", onNew);
    socket.on("alert:update", onUpdate);
    socket.on("alert:delete", onDelete);
    
    return () => {
      socket.off("alert:new", onNew);
      socket.off("alert:update", onUpdate);
      socket.off("alert:delete", onDelete);
    };
  }, [studentId]); // Reconnect when studentId changes
};